import { FormItemTypes, isNullOrUndefined } from '@bimser/core';

export function proxyCreator<T extends object>(
	obj: T,
	setterMethod: (value: any, name: string[]) => void,
	propertyPath?: string[]
): T {
	const handler: ProxyHandler<T> = {
		get(target: any, key: string) {
			let isOwnProperty = true;
			let targetItemInstance;
			if (target.controlType) {
				if (
					target.controlType ===
					FormItemTypes.EControlTypes[target.controlType as FormItemTypes.EControlTypes]
				) {
					targetItemInstance = new target.__proto__.constructor();
				} else {
					targetItemInstance = new target.constructor.prototype.__proto__.constructor();
				}
			}

			if (targetItemInstance) {
				isOwnProperty = targetItemInstance[key] ? true : false;
			}

			const isTargetObject = typeof target[key] === 'object';
			const isTargetDateObject =
				Object.prototype.toString.call(target[key]) === '[object Date]';

			if (
				!isNullOrUndefined(target[key]) &&
				isTargetObject &&
				!isTargetDateObject &&
				!key.startsWith('__') &&
				isOwnProperty
			) {
				let path: string[] = [];
				if (propertyPath) {
					path = propertyPath;
				}
				return proxyCreator(target[key], setterMethod, [...path, key]);
			} else {
				return target[key];
			}
		},
		set(target, key: string, value) {
			let path: string[] = [];
			if (propertyPath) {
				path = propertyPath;
			}
			if (!key.startsWith('__')) {
				setterMethod(value, [...path, key]);
			} else {
				(target as any)[key] = value;
			}
			return true;
		}
	};

	return new Proxy(obj, handler);
}
